module.exports = __webpack_public_path__ + "img/32.53c53d7.jpg";